<template>
  <div class="assess-page">

    <vue-basic-alert :duration="400" ref="alert" />

    <!-- ───────────── LOGIN VIEW ───────────── -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
        <h2>Please Login First</h2>
        <p>You must login before continuing to Other Payments.</p>
        <router-link to="/login" class="login-btn">Login</router-link>
      </div>
    </div>

    <!-- ───────────── MAIN PAGE ───────────── -->
    <div v-else>

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Online Payment</p>
            <h1 class="page-title">Other Payments</h1>
            <p class="page-subtitle">
              Select your Pradeshiya Sabha and enter payment details
            </p>
          </div>
        </div>

        <router-link to="/otherpaymentshistory" class="history-btn">
          Payment History
        </router-link>
      </div>

      <!-- FORM -->
      <form id="ShopRentForm" @submit="handleSubmit" novalidate autocomplete="off">

        <!-- STEP 1: Sabha Selection -->
        <div class="form-card">
          <div class="card-header">
            <div class="step-badge">1</div>
            <div>
              <h3 class="card-title">Select Pradeshiya Sabha</h3>
              <p class="card-desc">Choose the relevant council</p>
            </div>
          </div>

          <div class="fields-grid two-col">
            <div class="field-group">
              <label>Select Pradeshiya Sabha</label>
              <div class="select-wrapper">
                <select @change="AllShopData" class="field-input" name="pradeshiya" id="pradeshiya" v-model="rentObj.pra_sabha">
                <option value="" selected disabled>Choose a Sabha</option>
                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">
                  {{ ps.sb_name_en }} | {{ ps.sb_name_sin }}
                </option>
              </select>
              </div>
              <p class="field-error" v-if="errorObj.praErr.length">
                {{ errorObj.praErr[0] }}
              </p>
            </div>
          </div>
        </div>

        <!-- STEP 2: Payment Details -->
        <div
          v-if="rentObj.pra_sabha"
          class="form-card"
        >
          <div class="card-header">
            <div class="step-badge">2</div>
            <div>
              <h3 class="card-title">Payment Details</h3>
              <p class="card-desc">
                Enter all information related to your payment
              </p>
            </div>
          </div>

          <div class="fields-grid two-col">

            <!-- Amount -->
            <div class="field-group">
              <label>Pay Amount (Rs)</label>
              <input
                type="number"
                class="field-input"
                v-model="rentObj.Payment"
                placeholder="Enter payment amount"
              />
              <p class="field-error" v-if="errorObj.PaymentErr.length">
                {{ errorObj.PaymentErr[0] }}
              </p>
            </div>

            <!-- Remarks -->
            <div class="field-group">
              <label>Remarks</label>
              <textarea
                rows="3"
                class="field-input"
                v-model="rentObj.paydes"
                placeholder="Type payment description"
              ></textarea>
              <p class="field-error" v-if="errorObj.paydesErr.length">
                {{ errorObj.paydesErr[0] }}
              </p>
            </div>

          </div>
        </div>

        <!-- Submit -->
        <div class="form-actions" v-if="rentObj.pra_sabha">
          <button type="submit" class="continue-btn">
            Continue →
          </button>
        </div>

      </form>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert'
export default {
   name: "AssessmentTax",

   data() {
        return {
            userNic:'',Nic:'',
            rentObj: { pro:"",dis:"",pra_sabha:"",paydes:"",Payment:""},
            errorObj: { disErr: [],proErr: [], praErr: [], paydesErr: [], PaymentErr: []},
            p_sabha:[],
            SabhaData:undefined,
            Sabha:undefined,
            matchUser:undefined,
            matchPaymonth:[],
           

         //   checkVal:[],payamount:{},
            AllShopDtails: [],
           
            Districts: [],
            DistrictsData:undefined,
            sDist:undefined,
           
            // distMatch: undefined,
            province: [],
            
            // distMatch: undefined,
            len:0,len2:0,
            currentDate: new Date(),
            nextid:'',onlinPaydata:[],
            sabhaCode:'',

           
        
        }
    },

        created() {
        
            this.getSessionData();
            this.AllprSabha();
            // this.loard();
            // this.AllShopData();
        },
     
        computed : {
            ...mapState(["user"]),
         
            
        },
     
    methods: {
      ...mapMutations(["setUser"]),
         async MatchUser(nic) {
               let data = await axios.get('/customersdata/' + nic);
               this.matchUser = data.data;
         },
     
         scrollToTop() {
    window.scrollTo(0, 0);
  },
         async getSessionData(){
         const data=JSON.parse(sessionStorage.getItem('Userdata'));
         if(data){
            this.Nic=data.Unic;
            this.sabhaCode=data.Usabha;
         }
            await this.MatchUser(this.Nic);
            this.setUser(this.matchUser);
            await axios.delete('/delotherpaybynictemp/'+this.user.cus_nic );
            await axios.delete('/onlinepaymenttemp/'+this.user.cus_nic );
            // window.sessionStorage.removeItem('rentDetails');
            // window.sessionStorage.removeItem('shopDataid');

            
         },

        async AllprSabha() {
            try {
               const allsabhaResponse = await axios.get('/customersabha/' + this.Nic);
               const allsabha = allsabhaResponse.data;

               if (allsabha && allsabha.length > 0) {
                  this.p_sabha = [];

                  for (const sabha of allsabha) {
                  if (sabha.sabha) {
                     const psabhaResponse = await axios.get('/PraSabhadata/' + sabha.sabha);
                     this.p_sabha.push(...psabhaResponse.data);
                  }
                  }

                  // console.log('All Sabha Data:', this.p_sabha);
               } else {
                  console.error('No sabha found for this NIC.');
               }
            } catch (error) {
               console.error('Error fetching sabha data:', error);
            }
            },
   
        async changeprovince() {

                let DistrictsData = (await  axios.get('/districts/' +this.rentObj.pro));
                this.Districts=DistrictsData.data
            
       },
      async changedist() {
            
            let SabhaData = (await axios.get('/Prasabha/' + this.rentObj.dis));
            this.p_sabha=SabhaData.data;
          
            
       },
      //   async AllShopData() {
      //    document.getElementById('pay').style.display ='block';
           
          
      //   },
         
        resetCheckErr: function () {
            this.errorObj.disErr = [];
            this.errorObj.proErr= [];
            this.errorObj.praErr = [];
            this.errorObj.taxNumErr = [];
            this.errorObj.PaymentErr = [];
            this.errorObj.paydesErr = [];
            this.errorObj.wardErr = [];
            this.errorObj.streetErr = [];
           
           
            
        },
        resetObjects: function(){
            this.rentObj.dis="";
            this.rentObj.pro="";
            this.rentObj.pra_sabha="";
            this.rentObj.paydes="";
            this.rentObj.Payment="";
          
         
        },
        checkEmptyErr: function () {
            for (var typeErr in this.errorObj) {
                if (this.errorObj[typeErr].length != 0) {
                    return false;
                }
            }
            return true;
        },
         checkForm: function () {
            this.resetCheckErr();

        
           
            // Month Validate
            if (!this.rentObj.Payment) {
                this.errorObj.PaymentErr.push("Please Enter Pay Amount");
            }
            else{
                    if(!/[0-9]/.test(this.rentObj.Payment)) {
                    this.errorObj.PaymentErr.push('Pay Amount should be numbers');
                    }
                 }
          
 
          
     // Rent Des validate
     if (!this.rentObj.paydes) {
                this.errorObj.paydesErr.push("Description is required");
            
            }
       
        },

        async handleSubmit(e) {
           this.checkForm();
           
                if (!this.checkEmptyErr()) {
                    e.preventDefault();
                } else {
                 e.preventDefault();
                
                    if(!this.user){
                        this.$refs.alert.showAlert('error','Please Loging to Continue !')
                    }
                    else{

                     this.onlinPaydata= (await axios.get('/genarateinvonline/'+this.rentObj.pra_sabha)).data;
                     let lastGennum=parseInt(this.onlinPaydata[0].gen_num);
           
           let InvouceNum= (this.rentObj.pra_sabha.concat(this.currentDate.getMonth(),this.currentDate.getFullYear(),lastGennum));
           this.nextid= lastGennum+1;

              const genInvNum = {
                 gen_num:this.nextid,
              }
              await axios.put('/updateinvonline/'+this.rentObj.pra_sabha,genInvNum);
            let paymenttax=parseFloat(this.rentObj.Payment).toFixed(2)
                     const data = {
                        sabha_code:this.rentObj.pra_sabha,
                        remark: this.rentObj.paydes,
                        taxtPayment:paymenttax,
                        invoiceNum:InvouceNum,
                        // payamount:this.rentObj.payamount,
                        }

                        // console.log("test sss");
                    sessionStorage.setItem('payDetails',JSON.stringify(data));
                     //  sessionStorage.setItem('payamounts',JSON.stringify(this.payamount));

                           // console.log("test sss");


                           // sessionStorage.setItem('sessionid',"hjhj");
                           // sessionStorage.setItem('successid',"ghghg");
                           
                                 this.$router.push("/otherpaymentsinvoice");
                     // }
                     // else{
                     //    this.$refs.alert.showAlert('error',"Please Enter Pay Amount and  Select to Pay ")
                     // }
                //     this.resetObjects();
                // sessionStorage.removeItem("usernic");
                }
            }
        }
        
      
    },
    components: {
        VueBasicAlert
    }

};

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.assess-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}

.page-body,
form#ShopRentForm {
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}

/* ── Login Prompt ── */
.login-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}
.login-card {
  background: #fff;
  border-radius: 1.4rem;
  padding: 4rem 3.5rem;
  text-align: center;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p { font-size: 1.45rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1.1rem 2.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.5rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.8rem; gap: 1.5rem; flex-wrap: wrap;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.4rem; color: #7a6258; margin: 0; }

.history-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.9rem 1.8rem;
  border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff;
  border-radius: 0.8rem; font-size: 1.4rem; font-weight: 500;
  text-decoration: none; transition: all 0.2s; white-space: nowrap;
}
.history-btn svg { width: 1.7rem; height: 1.7rem; }
.history-btn:hover { background: #c2440a; color: #fff; }

/* ── Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.4rem;
  margin-bottom: 1.6rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  transition: box-shadow 0.2s;
}
.form-card:hover { box-shadow: 0 4px 18px rgba(100,50,30,0.1); }

.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem;
  border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; font-size: 1.6rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.card-icon-sm {
  width: 4rem; height: 4rem; border-radius: 0.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.card-icon-sm svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Fields ── */
.fields-grid { 
  /* display: grid;  */
  gap: 1.6rem 2rem; }
.four-col { grid-template-columns: repeat(4, 1fr); }
.two-col { grid-template-columns: repeat(2, 1fr); }

.field-group { display: flex; flex-direction: column; gap: 0.5rem; }
.field-group label { font-size: 1.3rem; font-weight: 500; color: #4a3028; }

.field-input {
  width: 100%; padding: 1rem 1.3rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; color: #1c0f0a;
  background: #faf8f6; border: 1.5px solid #ddd4ca; border-radius: 0.7rem;
  outline: none; appearance: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.field-input:focus { border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.1); }
.field-input::placeholder { color: #bfb0a5; }
.field-input[readonly] { opacity: 0.75; cursor: default; }

.select-wrapper { position: relative; }
.select-wrapper .field-input { padding-right: 3.5rem; cursor: pointer; }
.select-arrow {
  position: absolute; right: 1rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; stroke: #9a8070; pointer-events: none;
}

.field-error { font-size: 1.2rem; color: #dc2626; margin: 0; }

/* ── Search btn ── */
.search-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 1rem 2rem; width: 100%; justify-content: center;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.7rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.45rem; font-weight: 600;
  cursor: pointer; transition: all 0.2s;
}
.search-btn svg { width: 1.7rem; height: 1.7rem; }
.search-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.3); }

/* ── Section Divider ── */
.section-divider {
  display: flex; align-items: center; gap: 1rem;
  margin: 2rem 0; color: #9a8070; font-size: 1.3rem;
}
.section-divider::before, .section-divider::after {
  content: ''; flex: 1; height: 1px; background: #e5ddd5;
}

/* ── Alert msg ── */
.alert-msg {
  display: flex; align-items: center; gap: 0.8rem;
  background: #fff3e0; border: 1px solid #ffd180;
  border-radius: 0.7rem; padding: 1rem 1.4rem;
  font-size: 1.4rem; color: #e65100; margin-top: 1.5rem;
}
.alert-msg svg { width: 1.8rem; height: 1.8rem; flex-shrink: 0; }

/* ── Info Fields ── */
.info-field { display: flex; flex-direction: column; gap: 0.4rem; }
.info-label { font-size: 1.2rem; font-weight: 500; color: #9a8070; text-transform: uppercase; letter-spacing: 0.05em; }
.info-value { font-size: 1.5rem; font-weight: 600; color: #1c0f0a; }

/* ── Tables ── */
.table-wrapper { overflow-x: auto; border-radius: 0.8rem; border: 1px solid #e5ddd5; }
.data-table { width: 100%; border-collapse: collapse; font-size: 1.4rem; }
.data-table th {
  background: #f5f0ea; color: #4a3028; font-weight: 600;
  padding: 1.1rem 1.5rem; text-align: center; border-bottom: 2px solid #e5ddd5;
  white-space: nowrap;
}
.data-table td { padding: 1rem 1.5rem; text-align: center; border-bottom: 1px solid #f0ebe3; color: #2c1a10; }
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.quarter-label { text-align: left !important; font-weight: 500; }

.badge-paid   { background: #dcfce7; color: #15803d; padding: 0.25rem 0.9rem; border-radius: 99px; font-size: 1.2rem; font-weight: 600; }
.badge-unpaid { background: #fee2e2; color: #b91c1c; padding: 0.25rem 0.9rem; border-radius: 99px; font-size: 1.2rem; font-weight: 600; }

.row-reversal { background: #fff7ed; font-style: italic; color: #c2410c; }
.row-excess   { background: #eff6ff; color: #1d4ed8; }
.row-arrears  { background: #fef2f2; }
.row-balance  { background: #f0fdf4; }

/* ── Payment Layout ── */
.payment-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 2.4rem; }

.payment-desc-box {
  background: #faf8f6; border: 1px solid #e5ddd5;
  border-radius: 0.9rem; overflow: hidden;
}
.desc-title {
  font-family: 'DM Serif Display', serif; font-size: 1.6rem;
  color: #1c0f0a; margin: 0; padding: 1.2rem 1.6rem;
  border-bottom: 1px solid #e5ddd5; background: #f0ebe3;
}
.desc-content { padding: 1.2rem 1.6rem; font-size: 1.35rem; line-height: 1.7; color: #4a3028; white-space: pre-line; }
.due-amount-box {
  display: flex; flex-direction: column; padding: 1.2rem 1.6rem;
  background: #7c2d12; border-top: none;
}
.due-label { font-size: 1.2rem; color: rgba(255,255,255,0.75); margin-bottom: 0.2rem; }
.due-value { font-size: 1.9rem; font-weight: 700; color: #fff; }

.payment-inputs { display: flex; flex-direction: column; gap: 1.6rem; }

.input-with-icon { display: flex; align-items: center; }
.input-prefix {
  background: #f0ebe3; border: 1.5px solid #ddd4ca; border-right: none;
  border-radius: 0.7rem 0 0 0.7rem; padding: 1rem 1.2rem;
  font-size: 1.4rem; font-weight: 600; color: #7c2d12; white-space: nowrap;
}
.input-prefix.fine    { color: #b91c1c; background: #fff5f5; border-color: #fecaca; }
.input-prefix.success { color: #15803d; background: #f0fdf4; border-color: #bbf7d0; }
.input-with-icon .field-input.prefixed { border-radius: 0 0.7rem 0.7rem 0; }
.fine-input    { border-color: #fecaca; }
.success-input { border-color: #bbf7d0; }

/* ── Form Actions ── */
.form-actions { display: flex; justify-content: flex-end; margin-top: 0.4rem; }
.continue-btn {
  display: inline-flex; align-items: center; gap: 0.8rem;
  padding: 1.2rem 3rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 600;
  cursor: pointer; box-shadow: 0 4px 14px rgba(124,45,18,0.3);
  transition: all 0.2s;
}
.continue-btn svg { width: 1.8rem; height: 1.8rem; }
.continue-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(124,45,18,0.4); }

/* ── Responsive ── */
@media (max-width: 1024px) { .four-col { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) {
  .assess-page { padding: 1.5rem 1.2rem 3rem; }
  .four-col, .two-col { grid-template-columns: 1fr; }
  .payment-layout { grid-template-columns: 1fr; }
  .page-title { font-size: 2rem; }
  .page-header { flex-direction: column; }
  .form-actions { justify-content: stretch; }
  .continue-btn { width: 100%; justify-content: center; }
}
</style>
